var _a, _b;
import { __decorate, __metadata } from "tslib";
import mtzService from "@/core/services/mtzService";
import JwtService from "@/core/services/JwtService";
import { Mutations } from "@/store/enums/StoreEnums";
import { ResponsabilidadeAtividadeActions } from "@/store/enums/mtzEnums";
import { Module, Action, VuexModule } from "vuex-module-decorators";
let ResponsabilidadeAtividadeModule = class ResponsabilidadeAtividadeModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.errors = {};
        this.isAuthenticated = !!JwtService.getToken();
    }
    [_a = ResponsabilidadeAtividadeActions.SALVAR_PARAMETRIZACAO](data) {
        return new Promise(resolve => {
            mtzService.post("Responsabilidade_Atividade/SalvarParametrizacaoIndicadores", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_b = ResponsabilidadeAtividadeActions.GET_RESPONSABILIDADE_ATIVIDADE_POR_FUNCAO_ID](id) {
        return new Promise(resolve => {
            mtzService.get("Responsabilidade_Atividade/GetPorFuncaoId", id)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
};
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ResponsabilidadeAtividadeModule.prototype, _a, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ResponsabilidadeAtividadeModule.prototype, _b, null);
ResponsabilidadeAtividadeModule = __decorate([
    Module
], ResponsabilidadeAtividadeModule);
export default ResponsabilidadeAtividadeModule;
//# sourceMappingURL=Responsabilidade_AtividadeModule.js.map